import React from 'react';

// DEMO IMAGES (replace with your actual images in ../../assets/images)
import testimonialUser from '../../assets/images/cat-mugs.jpg';
import iconPrinting from '../../assets/images/cat-hampers.jpg';
import iconDesignTools from '../../assets/images/cat-giftcards.jpg';
import iconDelivery from '../../assets/images/cat-tech.jpg';
import iconSatisfaction from '../../assets/images/cat-fashion.jpg';
// import use navigate
import { useNavigate } from 'react-router-dom';
export default function AboutUs() {
  const navigate = useNavigate();
  return (
    <div className="bg-white text-[#2F2F2F]">
      {/* HERO / INTRO SECTION */}
      <section className="max-w-5xl mx-auto px-4 py-12 text-center">
        <h1 className="text-3xl md:text-4xl font-bold mb-4">
          Our Story: Turning Ideas into Reality
        </h1>
        <p className="max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
          At [Your Company Name], we started with a simple vision: to make
          high-quality custom printing accessible to everyone—from small
          businesses and startups to individuals with creative ideas. Our
          journey began when we noticed how challenging it was to get
          professional printing services, especially for those without
          design experience.
        </p>
        <p className="max-w-3xl mx-auto text-base md:text-lg leading-relaxed mt-4">
          With a passion for design and printing, we built an easy-to-use
          platform that allows anyone to create and order professional-quality
          prints. Our advanced design tools, extensive product range, and
          flexible services bring ideas to life with stunning, customized products.
        </p>
      </section>

      {/* WHAT SETS US APART SECTION */}
      <section className="py-12">
  <h2 className="text-center text-[#00148c] text-3xl md:text-4xl font-extrabold mb-10">
    What Sets Us Apart?
  </h2>

  {/* 
    3×3 grid on medium screens and above:
      - Top card:    row 1, col 2
      - Left card:   row 2, col 1
      - Right card:  row 2, col 3
      - Bottom card: row 3, col 2
    
    On mobile (below md), it just stacks in 1 column. 
  */}
  <div className="
    max-w-6xl mx-auto px-4
    grid grid-cols-1 gap-8 place-items-center
    md:grid-cols-3 md:grid-rows-3
  ">

    {/* Top (row 1, col 2) */}
    <div className="
      md:row-start-1 md:col-start-2
      border-[3px] border-black rounded-[30px] p-6
      w-full text-left space-y-4
    ">
      <h3 className="text-xl md:text-2xl font-bold text-[#2F2F2F]">
        User-Friendly Design Tools
      </h3>
      <p className="text-sm md:text-base text-[#4E4E4E] leading-relaxed">
        No design experience? No problem! Our intuitive drag-and-drop editor
        and professionally crafted templates make designing easy for everyone.
      </p>
    </div>

    {/* Left (row 2, col 1) */}
    <div className="
      md:row-start-2 md:col-start-1
      border-[3px] border-black rounded-[30px] p-6
      w-full text-left space-y-4
    ">
      <h3 className="text-xl md:text-2xl font-bold text-[#2F2F2F]">
        Exceptional Customer Support
      </h3>
      <p className="text-sm md:text-base text-[#4E4E4E] leading-relaxed">
        Need help? Our expert support team is available to assist you with
        technical questions, order tracking, and personalized recommendations.
      </p>
    </div>

    {/* Right (row 2, col 3) */}
    <div className="
      md:row-start-2 md:col-start-3
      border-[3px] border-black rounded-[30px] p-6
      w-full text-left space-y-4
    ">
      <h3 className="text-xl md:text-2xl font-bold text-[#2F2F2F]">
        Fast Turnaround &amp; Reliable Shipping
      </h3>
      <p className="text-sm md:text-base text-[#4E4E4E] leading-relaxed">
        We know time is crucial. Our efficient printing process and quick
        delivery options ensure you get your orders on time.
      </p>
    </div>

    {/* Bottom (row 3, col 2) */}
    <div className="
      md:row-start-3 md:col-start-2
      border-[3px] border-black rounded-[30px] p-6
      w-full text-left space-y-4
    ">
      <h3 className="text-xl md:text-2xl font-bold text-[#2F2F2F]">
        Comprehensive Branding Solutions
      </h3>
      <p className="text-sm md:text-base text-[#4E4E4E] leading-relaxed">
        More than just printing, we offer marketing services, website design,
        and custom branding packages to help businesses grow.
      </p>
    </div>

  </div>
</section>



      {/* PRINTING MADE EASY SECTION (DIAMOND LAYOUT) */}
      <section className="max-w-5xl mx-auto px-4 py-12 text-center">
        <h2 className="text-2xl md:text-3xl font-bold mb-8">
          Printing Made Easy
        </h2>

        {/* On small screens, stack them vertically in order.
            On medium+ screens, arrange in a diamond with a 3x3 grid. */}
        <div className="flex flex-col items-center space-y-8 md:space-y-0 md:grid md:grid-rows-3 md:grid-cols-3 md:gap-8 max-w-3xl mx-auto">
          {/* 1) Design Tools => top center (row1 col2) */}
          <div className="md:row-start-1 md:col-start-2 flex flex-col items-center">
            <img
              src={iconDesignTools}
              alt="Design Tools"
              className="w-24 h-24 object-contain mb-3"
            />
            <h4 className="font-semibold text-lg mb-1 text-[#00148c]">Design Tools</h4>
            <p className="text-sm text-[#4E4E4E] max-w-xs">
              Easy-to-use online editor with templates and customization.
            </p>
          </div>

          {/* 2) Custom Printing => middle left (row2 col1) */}
          <div className="md:row-start-2 md:col-start-1 flex flex-col items-center">
            <img
              src={iconPrinting}
              alt="Custom Printing"
              className="w-24 h-24 object-contain mb-3"
            />
            <h4 className="font-semibold text-lg mb-1 text-purple-700">Custom Printing</h4>
            <p className="text-sm text-[#4E4E4E] max-w-xs">
              High-quality prints for business and personal needs.
            </p>
          </div>

          {/* 3) Fast Delivery => middle right (row2 col3) */}
          <div className="md:row-start-2 md:col-start-3 flex flex-col items-center">
            <img
              src={iconDelivery}
              alt="Fast Delivery"
              className="w-24 h-24 object-contain mb-3"
            />
            <h4 className="font-semibold text-lg mb-1 text-[#F7941D]">Fast Delivery</h4>
            <p className="text-sm text-[#4E4E4E] max-w-xs">
              Quick turnaround with reliable shipping.
            </p>
          </div>

          {/* 4) Customer Satisfaction => bottom center (row3 col2) */}
          <div className="md:row-start-3 md:col-start-2 flex flex-col items-center">
            <img
              src={iconSatisfaction}
              alt="Customer Satisfaction"
              className="w-24 h-24 object-contain mb-3"
            />
            <h4 className="font-semibold text-lg mb-1 text-pink-600">Customer Satisfaction</h4>
            <p className="text-sm text-[#4E4E4E] max-w-xs">
              24/7 support and money-back guarantee.
            </p>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS SECTION */}
      <section className="bg-[#F8F5F2] py-12">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Trusted by Thousands of Businesses &amp; Creators
          </h2>
          <p className="max-w-2xl mx-auto text-[#4E4E4E] mb-8">
            “Ut Eum Voluptas Aut Sit Ab. Placeat Eaque Est Nihil Cumque Sed Sit 
            Asperiores Tempore Et. Error Omnis Culpa Autem. Molestias Omnis Quo 
            Et Voluptatem Natus Adipisci Corpora. Quia Voluptas Expedita Qui Et Rem 
            Facere Autem.”
          </p>
          {/* Single Testimonial Example */}
          <div className="bg-white shadow-md rounded-lg p-6 inline-block text-left">
            <div className="flex items-center mb-4">
              <img
                src={testimonialUser}
                alt="User Avatar"
                className="w-12 h-12 rounded-full object-cover mr-3"
              />
              <div>
                <h4 className="font-semibold text-[#00148c]">Mercedes Kirin</h4>
                <p className="text-sm text-[#4E4E4E]">Graphics Designer</p>
              </div>
            </div>
            <p className="text-sm text-[#4E4E4E] leading-relaxed">
              "Their design tools and printing options have transformed our 
              marketing approach. The quality is unmatched and the process 
              couldn’t be simpler!"
            </p>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="bg-[#00148c] py-12 text-center">
        <h3 className="text-xl md:text-2xl font-bold text-white mb-4">
          Bring Your Ideas to Life Today!
        </h3>
        <button className="bg-[#FFD100] text-black font-semibold text-sm py-3 px-6 border border-gray-500 rounded hover:bg-[#FFCA00]"
          onClick={() => navigate('/product-categories')}
        >
          Browse Our Product Categories & Start Designing
        </button>
      </section>
    </div>
  );
}
